export const PRINT_CUSTOM_STYLES_A4 = {
  spacingSize: 14,
  halfSpacingSize: 7,
  horizontalItemGridSpacing: 4,
  verticalItemGridSpacing: 2,
  itemImgSize: 50,
  urlLogoSize: 50,
  mainTitleTextSize: 20,
  sectionTitleTextSize: 13,
  regularTextSize: 11,
  smallTextSize: 9,
}

export const PRINT_CUSTOM_STYLES_A5 = {
  spacingSize: 8,
  halfSpacingSize: 4,
  horizontalItemGridSpacing: 3,
  verticalItemGridSpacing: 1.5,
  itemImgSize: 28,
  urlLogoSize: 28,
  mainTitleTextSize: 18,
  sectionTitleTextSize: 13.5,
  regularTextSize: 11,
  smallTextSize: 9,
}

export const DISPLAY_CUSTOM_STYLES = {
  spacingSize: 16,
  halfSpacingSize: 8,
  horizontalItemGridSpacing: 6,
  verticalItemGridSpacing: 3,
  itemImgSize: 38,
  urlLogoSize: 38,
  mainTitleTextSize: 23,
  sectionTitleTextSize: 15,
  regularTextSize: 13,
  smallTextSize: 11,
}